export enum ResultCodeEnum {
    ResultRight = 10,
    ResultWrong = 20,
    ResultRetry = 30,
    ResultPass = 40,
    ResultRightWrongRight = 50,
    ResultRightWrongWrong = 60
}
